
import WithModel from '@/mixins/withModel';
import { mixins, Options } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';

@Options({})
export default class cordovaMap extends mixins(WithModel) {

    @Prop() userPosition!: OM.LatLong;
    @Prop() center!: OM.LatLong;
    @Prop() markers!: OM.VillageTrip[];

    mounted() {
        this.init();
    }

    beforeUnmount() {
        this.beforeUnmountFn();
    }
    beforeUnmountFn = () => {};

    async init() {
        const mapDiv = this.$refs.mapElement as HTMLDivElement;

        let map = window.plugin.google.maps.Map.getMap(mapDiv, {
            controls: {
                compass: false,
                myLocationButton: false,
                indoorPicker: false,
                zoom: false,
                mapToolbar: false
            },
            gestures: {
                scroll: true,
                tilt: false,
                rotate: false,
                zoom: true
            },
            camera: {
                target: {
                    lat: this.center.lat,
                    lng: this.center.long
                },
                zoom: 12
            }
        });

        map.on(window.plugin.google.maps.event.MAP_READY, () => {
            this.renderMarkers(map);
            this.renderUserMarker(map);
        });

        this.beforeUnmountFn = () => {
            map.remove();
        }

        this.setCenterFn = (val: OM.LatLong) => {
            map.animateCamera({
                target: {
                    lat: val.lat,
                    lng: val.long
                },
                duration: 400
            });
        }

    }

    renderMarkers(map) {
        this.markers.forEach((x) => {
            console.log(x.image.publicUrl);
            map.addMarker({
                position: {
                    lat: x.position.lat,
                    lng: x.position.long
                },
            }, (marker) => {
                marker.setIcon({
                    url: x.roundIcon.publicUrl,
                    // size: {
                    //     width: 52,
                    //     height: 52
                    // }
                });
                marker.on(window.plugin.google.maps.event.MARKER_CLICK, () => {
                    this.$emit("markerClick", x);
                });
            });
        });
    }

    renderUserMarker(map) {
        map.addMarker({
            position: {
                lat: this.userPosition.lat,
                lng: this.userPosition.long
            },
            icon: {
                url:  "img/icon-location.png", // NB: deve essere nel www root se da file
                size: {
                    width: 52,
                    height: 52
                }
            }
        }, (marker) => {
            
            this.positionChangeFn = (val: OM.LatLong) => {
                marker.setPosition({
                    lat: val.lat,
                    lng: val.long
                });
            }
        });
    }

    setCenterFn = (val: OM.LatLong) => {
    }

    positionChangeFn = (val: OM.LatLong) => {
    }

    @Watch('userPosition')
    @Watch('userPosition.lat')
    @Watch('userPosition.long')
    onPositionChange() {
        this.positionChangeFn(this.userPosition);
    }

    @Watch('center')
    @Watch('center.lat')
    @Watch('center.long')
    onCenterChange() {
        this.setCenterFn(this.center);
    }
}
